import { FilterMetadataApiWithCountReturn, PROVIDER_CONNECTION_TYPE } from "../Components/misc";
import _ from "lodash";
import { uppercaseFirst } from "./uppercaseFirst";

export const getConnectionSizeMedianText = (
    metadata?: FilterMetadataApiWithCountReturn,
    connectionSizeCategory?: string
) => {
    if (!metadata || !connectionSizeCategory) return "";

    const providerSizeOptions = metadata?.["providerSize"]?.options ?? [];
    const sizeKeyToProviderSizeOption = _.keyBy(providerSizeOptions, d => d.value);
    const connectionSizeText =
        connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk
            ? "bulk"
            : sizeKeyToProviderSizeOption?.[connectionSizeCategory]?.label ?? "";

    return `${uppercaseFirst(connectionSizeText)} provider median`;
};
